import { render, staticRenderFns } from "./MetricUI.vue?vue&type=template&id=e05abd44&scoped=true"
import script from "./MetricUI.vue?vue&type=script&lang=js"
export * from "./MetricUI.vue?vue&type=script&lang=js"
import style0 from "./MetricUI.vue?vue&type=style&index=0&id=e05abd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05abd44",
  null
  
)

export default component.exports